import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PropertyService} from '../services/property.service';
import {BuildingApiService} from '../../../../services/api/building-api.service';
import {ICorporationNumber} from '../../../../types/api-response/building/corporation-number';
import {AlertService} from '../../../../services/alert.service';
import {take} from 'rxjs/operators';

@Component({
    selector: 'corporation-detailed-view',
    templateUrl: './corporation-detailed-view.component.html',
    styleUrls: ['./corporation-detailed-view.component.scss']
})
export class CorporationDetailedViewComponent implements OnInit {

    private selectedCorporation: ICorporationNumber;

    /**
     * Selected corporation
     */
    @Input() set corporation(corporationDetails: ICorporationNumber) {
        if (corporationDetails === this.selectedCorporation) {
            return;
        }

        this.selectedCorporation = corporationDetails;

        if (corporationDetails) {
            this.updateSelectedBuildings();
        }
    }

    get corporation(): ICorporationNumber {
        return this.selectedCorporation;
    }

    /**
     * Detailed view close event
     */
    @Output() closeEvent = new EventEmitter();

    private companyOptions = [];
    private buildingOptions = [];

    selectedBuildings = [];

    isBuildingsLoading = false;

    constructor(
        public propertyService: PropertyService,
        private buildingApi: BuildingApiService,
        private alert: AlertService
    ) {
    }

    ngOnInit() {
    }

    private updateSelectedBuildings() {
        this.isBuildingsLoading = true;
        this.propertyService.buildings$
            .pipe(take(1))
            .subscribe(buildings => {
                const buildingIds: number[] = this.selectedCorporation.buildings ? <number[]>this.selectedCorporation.buildings : [];
                this.selectedBuildings = buildingIds
                    .map(buildingId => buildings.find(building => +building.id === +buildingId))
                    .map(building => ({id: building.id, itemName: building.name}));
                this.isBuildingsLoading = false;
            });
    }

    get companySelectOptions(): { value: string | number, optionText: string }[] {
        if (!this.companyOptions.length && this.propertyService.companies) {
            this.companyOptions = this.propertyService.companies.map(company => ({
                value: company.id,
                optionText: company.name
            }));
        }

        return this.companyOptions;
    }

    get buildingSelectOptions(): { id: string | number, itemName: string }[] {
        if (!this.buildingOptions.length && this.propertyService.companies) {
            this.buildingOptions = this.propertyService.buildingsList.map(building => ({
                id: building.id,
                itemName: building.name
            }));
        }

        return this.buildingOptions;
    }

    close() {
        this.closeEvent.next();
    }

    updateCorporation(corporation: Partial<ICorporationNumber>) {
        this.buildingApi.updateCorporationNumber({...corporation, id: this.corporation.id}).subscribe(result => {
            Object.keys(corporation).forEach(key => this.corporation[key] = result[key]);
            this.alert.toast.success('Corporation updated');
        }, () => this.alert.toast.error('Failed to save changes'));
    }

    updateCorporationBuildings(selectedBuildings: { id: string | number, itemName: string }[]) {

        this.updateCorporation({buildings: selectedBuildings.map(item => +item.id)});
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/corporation-detailed-view/corporation-detailed-view.component.ts